const asCount = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
};

export const PLAYER_OWN_BOOKING_COLOR = '#06438B';

export const isPlayerOwnBooking = event => Boolean(event && event.booking);

export const playerBookingSlotColor = (event, fallbackColor) => (
  isPlayerOwnBooking(event) ? PLAYER_OWN_BOOKING_COLOR : fallbackColor
);

export const isMultiPlaceSlot = slot => asCount(slot && slot.presetPlaces) > 1;

export const availablePlaceCount = slot => asCount(slot && slot.availablePlaces);

export const totalPlaceCount = slot => asCount(slot && slot.presetPlaces);

export const isOpenMultiPlaceSlot = slot => (
  Boolean(slot) &&
  slot.state === 'available' &&
  isMultiPlaceSlot(slot) &&
  availablePlaceCount(slot) > 0
);

export const isFullAvailableSlot = slot => (
  Boolean(slot) &&
  slot.state === 'available' &&
  availablePlaceCount(slot) < 1
);

export const playerBookingSlotPresentation = event => {
  const slot = event && event.slot;

  if (!slot) return 'single';
  if (slot.state === 'reserved') return 'reserved';
  if (slot.state === 'unavailable') return 'unavailable';
  if (isPlayerOwnBooking(event)) return 'yours';
  if (isFullAvailableSlot(slot)) return 'booked';
  if (isOpenMultiPlaceSlot(slot) && slot.minimumPlayers !== null) return 'invitation';
  if (isOpenMultiPlaceSlot(slot)) return 'places';
  if (slot.bookingId) return 'booked';
  if (slot.minimumPlayers !== null) return 'invitation';
  if (isMultiPlaceSlot(slot)) return 'places';
  return 'single';
};

export const playerBookingSlotTitle = (event, genericTitles = []) => {
  const title = event && typeof event.title === 'string' ? event.title.trim() : '';
  if (!title) return null;
  if (!isPlayerOwnBooking(event)) return title;

  const normalizedGenericTitles = genericTitles
    .filter(Boolean)
    .map(value => String(value).trim().toLocaleLowerCase());

  return normalizedGenericTitles.includes(title.toLocaleLowerCase()) ? null : title;
};

export const bookingSlotAccessibleLabel = ({status, fieldName, startTime, endTime}) => [
  status,
  fieldName,
  startTime && endTime ? `${startTime}–${endTime}` : null
].filter(Boolean).join(', ');

export const compactCapacityLabel = (slot, t) => t('BOOKING_SLOT_CAPACITY_COMPACT', {
  available: availablePlaceCount(slot),
  total: totalPlaceCount(slot)
});

export const bookingParticipantNames = booking => {
  if (!booking) return [];

  const candidates = [
    ...(booking.users || []).map(user => user && user.bookingOwner),
    ...(booking.otherPlayers || [])
  ];
  const seen = new Set();

  return candidates.reduce((names, value) => {
    const name = typeof value === 'string' ? value.trim() : '';
    const key = name.toLocaleLowerCase();
    if (!name || seen.has(key)) return names;
    seen.add(key);
    names.push(name);
    return names;
  }, []);
};
